// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var ExclamationSign = function ExclamationSign(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M15.672 14.2L8.3 1.443a.352.352 0 00-.609 0L.328 14.2a.352.352 0 00.3.527h14.74a.352.352 0 00.304-.527zm-6.929-1.3a.221.221 0 01-.221.221H7.478a.221.221 0 01-.221-.221v-1.04a.221.221 0 01.221-.221h1.044a.221.221 0 01.221.221zm-.025-2.422H7.282l-.025-4.473h1.486z"
    }))
  );
};

export default ExclamationSign;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/ExclamationSign.js
// module id = 1003
// module chunks = 0